var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 59.5,
    r: 41.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9222 80.2508C48.3687 80.2508 43.0342 75.1318 43.0342 68.8383C43.0342 67.4543 43.2892 66.1034 43.7929 64.8211C45.5242 60.3972 49.9984 57.4258 54.9222 57.4258C61.4757 57.4258 66.8102 62.5448 66.8102 68.8383C66.8102 75.1318 61.4757 80.2508 54.9222 80.2508ZM54.9222 59.5008C50.8932 59.5008 47.2317 61.9327 45.8138 65.5515C45.4053 66.5994 45.1956 67.7053 45.1956 68.8383C45.1956 73.9864 49.5596 78.1758 54.9222 78.1758C60.2848 78.1758 64.6488 73.9864 64.6488 68.8383C64.6488 63.6902 60.2848 59.5008 54.9222 59.5008Z",
    fill: "#3377EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0208 80.2508C76.4673 80.2508 71.1328 75.1318 71.1328 68.8383C71.1328 62.5448 76.4673 57.4258 83.0208 57.4258C87.9446 57.4258 92.4188 60.3972 94.1502 64.8211C94.6538 66.1034 94.9088 67.4543 94.9088 68.8383C94.9088 75.1318 89.5744 80.2508 83.0208 80.2508ZM83.0208 59.5008C77.6583 59.5008 73.2943 63.6902 73.2943 68.8383C73.2943 73.9864 77.6583 78.1758 83.0208 78.1758C88.3834 78.1758 92.7474 73.9864 92.7474 68.8383C92.7474 67.7053 92.5377 66.5994 92.1292 65.5536C90.7113 61.9327 87.0498 59.5008 83.0208 59.5008Z",
    fill: "#3377EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2135 69.875C71.617 69.875 71.1328 69.4102 71.1328 68.8375V46.0125C71.1328 42.0077 74.5263 38.75 78.6979 38.75C81.8212 38.75 84.67 40.6362 85.781 43.4436C85.794 43.4768 85.8048 43.508 85.8134 43.5412L94.1502 64.8182C94.362 65.3556 94.0789 65.9532 93.519 66.1545C92.9635 66.3579 92.3367 66.086 92.1271 65.5486L83.7579 44.1865C83.7471 44.1574 83.7363 44.1305 83.7276 44.1014C82.8998 42.1094 80.935 40.825 78.6979 40.825C75.7173 40.825 73.2943 43.1531 73.2943 46.0125V68.8375C73.2943 69.4102 72.8101 69.875 72.2135 69.875Z",
    fill: "#3377EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7298 69.875C65.1332 69.875 64.6491 69.4102 64.6491 68.8375V46.0125C64.6491 43.1531 62.2261 40.825 59.2454 40.825C57.0061 40.825 55.0414 42.1094 54.2135 44.1035C54.2071 44.1325 54.1963 44.1595 54.1854 44.1865L45.8141 65.5528C45.6045 66.0881 44.9755 66.3599 44.4221 66.1587C43.8623 65.9574 43.5792 65.3598 43.791 64.8224L52.1299 43.5391C52.1407 43.5059 52.1515 43.4748 52.1623 43.4436C53.2733 40.6362 56.1221 38.75 59.2454 38.75C63.417 38.75 66.8105 42.0077 66.8105 46.0125V68.8375C66.8105 69.4102 66.3264 69.875 65.7298 69.875Z",
    fill: "#3377EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2135 57.4227H65.7292C65.1326 57.4227 64.6484 56.9579 64.6484 56.3852C64.6484 55.8125 65.1326 55.3477 65.7292 55.3477H72.2135C72.8101 55.3477 73.2943 55.8125 73.2943 56.3852C73.2943 56.9579 72.8101 57.4227 72.2135 57.4227Z",
    fill: "#3377EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2135 67.7977H65.7292C65.1326 67.7977 64.6484 67.3329 64.6484 66.7602C64.6484 66.1875 65.1326 65.7227 65.7292 65.7227H72.2135C72.8101 65.7227 73.2943 66.1875 73.2943 66.7602C73.2943 67.3329 72.8101 67.7977 72.2135 67.7977Z",
    fill: "#3377EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 137,
    height: 137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.863ce9a1c2808b66c0e19eeb36cef05d.svg";
export { ForwardRef as ReactComponent };